import request from './request'

export function getServiceTypeList(params) {
  return request({
    url: '/admin/service-types',
    method: 'get',
    params
  })
}

export function getServiceTypeOptions() {
  return request({
    url: '/admin/service-types/options',
    method: 'get'
  })
}

export function createServiceType(data) {
  return request({
    url: '/admin/service-types',
    method: 'post',
    data
  })
}

export function updateServiceType(id, data) {
  return request({
    url: `/admin/service-types/${id}`,
    method: 'put',
    data
  })
}

export function deleteServiceType(id) {
  return request({
    url: `/admin/service-types/${id}`,
    method: 'delete'
  })
}
